module.exports = __webpack_public_path__ + "static/media/liquidity_dark.f6c4a096.svg";